const d = 'M200-450v-60h560v60H200Z';

export default d;
